import { ToNumber } from "@pdfking/math"
import { NullQ } from "@pdfking/structs"

import type { ImpositionLeaf, PageEntry } from "#internal"

/**
 * A page as the numbering reads it, or nothing when the side it shows has no
 * place in its grow's reading order. Only its identity counts, so it is read
 * off the layout: nothing needs laying out for it.
 *
 * The path above the page — component, repetition, subject — is what pages
 * are grouped and read by; the grow's own place for this side comes last.
 */
export const PageEntryOf = (page: ImpositionLeaf): PageEntry | undefined => {
  const meta = page.data?.page
  if (!meta) return undefined
  const order = page.is_front ? meta.order_front : meta.order_rear
  if (NullQ(order)) return undefined
  if (!page.size) throw new Error(`numbered page ${page.guid.join("/")} names no size`)
  const prefix = page.guid.slice(0, -2)
  return {
    path: page.guid,
    group: NullQ(meta.page_group_id) ? prefix : [...prefix, meta.page_group_id],
    sequence: [...prefix.map(atom => ToNumber(atom as never)), order],
    is_front: page.is_front,
    meta,
    size: page.size,
  }
}
